import { Head } from '@components/head';
import { SimpleLayout } from '@components/ui/layouts/simple';
import { Grid, Link, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { routes } from '@routes';
import { Link as LinkReact } from 'react-router-dom';

export const NotFound = () => {
  return (
    <SimpleLayout>
      <Head title="Not Found" />
      <Grid container sx={{ minHeight: '100%' }}>
        <Grid
          xs={12}
          lg={12}
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Stack spacing={2} direction="column" width={400}>
            <Typography
              variant="h1"
              textAlign="center"
              fontSize="8rem!important"
              lineHeight="0.75"
            >
              404
            </Typography>
            <Typography variant="h3" textAlign="center">
              Page not found
            </Typography>
            <Link
              component={LinkReact}
              to={routes.home}
              underline="hover"
              color="text.primary"
              variant="button"
              textAlign="center"
            >
              Let's go home and try from there
            </Link>
          </Stack>
        </Grid>
      </Grid>
    </SimpleLayout>
  );
};
